/* NWIDEA — Header v3 : recherche mobile, drawer a11y, sous-menus, pastille panier */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';

  /* ---------- Sticky : l'annonce sort de l'écran, le header reste ---------- */
  var headerGroup = document.getElementById('header-group');
  var announcement = document.querySelector('.nwidea-announcement');
  if (headerGroup && announcement) {
    var syncStickyOffset = function () {
      headerGroup.style.setProperty('--nw-ann-offset', -announcement.getBoundingClientRect().height + 'px');
    };
    syncStickyOffset();
    window.addEventListener('resize', syncStickyOffset);
    if (window.ResizeObserver) new ResizeObserver(syncStickyOffset).observe(announcement);
  }

  /* ---------- --header-group-height : hauteur réellement visible du header ----------
     compiled_assets/styles.css (Horizon) pose body{--header-group-height: var(--header-height)}
     soit 60px en dur. Cette valeur est fausse ici : le header NWIDEA n'est pas un
     <header-component>, donc les calculs Horizon (theme.liquid, utilities.js, header.js)
     sortent tous en amont et ne la corrigent jamais.
     L'écriture doit se faire en style inline sur <body> : une variable posée sur <html>
     serait masquée pour tous les descendants de <body> par la règle body{...} ci-dessus.
     #header-group étant sticky et remonté de --nw-ann-offset, sa hauteur TOTALE
     (annonce + header) n'est pas le décalage utile : on mesure la partie encore visible
     sous le haut du viewport, qui passe de « annonce + header » à « header seul » au scroll.
     Mesure throttlée en rAF, écriture seulement si la valeur change. */
  if (headerGroup) {
    var lastGroupHeight = -1;

    var measureGroupHeight = function () {
      var rect = headerGroup.getBoundingClientRect();
      var visible = Math.max(0, Math.round(Math.min(rect.bottom, window.innerHeight || rect.bottom)));
      if (visible === lastGroupHeight) return;
      lastGroupHeight = visible;
      /* <body> pour gagner la cascade, <html> pour rester lisible hors de <body>. */
      document.documentElement.style.setProperty('--header-group-height', visible + 'px');
      document.body.style.setProperty('--header-group-height', visible + 'px');
    };

    var groupHeightQueued = false;
    var queueGroupHeight = function () {
      if (groupHeightQueued) return;
      groupHeightQueued = true;
      requestAnimationFrame(function () {
        groupHeightQueued = false;
        measureGroupHeight();
      });
    };

    measureGroupHeight();
    window.addEventListener('resize', queueGroupHeight);
    window.addEventListener('scroll', queueGroupHeight, { passive: true });
    window.addEventListener('orientationchange', queueGroupHeight);
    if (window.ResizeObserver) new ResizeObserver(queueGroupHeight).observe(headerGroup);
  }

  /* ---------- Recherche mobile (panneau repliable) ---------- */
  var searchBar = document.getElementById('nwidea-searchbar');
  var searchToggle = document.querySelector('.nwidea-header__searchtoggle');

  function setSearch(open) {
    if (!searchBar) return;
    searchBar.classList.toggle('open', open);
    searchBar.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var input = searchBar.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 60);
    }
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      setSearch(!searchBar.classList.contains('open'));
    });
  }
  var searchClose = searchBar && searchBar.querySelector('.nwidea-searchbar__close');
  if (searchClose) {
    searchClose.addEventListener('click', function () {
      setSearch(false);
      if (searchToggle) searchToggle.focus();
    });
  }

  /* ---------- Drawer (menu mobile) ---------- */
  var drawer = document.querySelector('.nwidea-drawer');
  var overlay = document.querySelector('.nwidea-drawer-overlay');
  var burger = document.querySelector('.nwidea-header__burger');

  function openDrawer() {
    if (!drawer) return;
    document.body.classList.add('nwidea-drawer-open');
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    var first = drawer.querySelector('.nwidea-drawer__close');
    if (first) setTimeout(function () { first.focus(); }, 80);
  }

  function closeDrawer() {
    if (!drawer) return;
    document.body.classList.remove('nwidea-drawer-open');
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (burger) {
      burger.setAttribute('aria-expanded', 'false');
      burger.focus();
    }
  }

  if (burger) burger.addEventListener('click', openDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  var drawerClose = drawer && drawer.querySelector('.nwidea-drawer__close');
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);

  /* ---------- Accordéons du drawer (lien distinct du bouton +/−) ---------- */
  var groups = drawer ? Array.prototype.slice.call(drawer.querySelectorAll('.nwidea-drawer__group')) : [];

  function setGroup(group, open) {
    var sub = group.querySelector('.nwidea-drawer__sub');
    if (!sub) return;
    sub.hidden = !open;
    group.classList.toggle('is-open', open);
    Array.prototype.forEach.call(group.querySelectorAll('[data-nwidea-sub]'), function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  groups.forEach(function (group) {
    Array.prototype.forEach.call(group.querySelectorAll('[data-nwidea-sub]'), function (btn) {
      btn.addEventListener('click', function () {
        var willOpen = btn.getAttribute('aria-expanded') !== 'true';
        groups.forEach(function (g) { if (g !== group) setGroup(g, false); });
        setGroup(group, willOpen);
      });
    });
  });

  /* ---------- Sous-menus de la navigation ordinateur ---------- */
  var ddItems = Array.prototype.slice.call(document.querySelectorAll('.nwidea-nav__item.has-dd'));

  function closeDd(item) {
    item.classList.remove('is-open');
    var t = item.querySelector('.nwidea-nav__trigger');
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  ddItems.forEach(function (item) {
    var trigger = item.querySelector('.nwidea-nav__trigger');
    if (!trigger) return;
    /* clic : bascule (indispensable au tactile ; le survol est géré en CSS) */
    if (trigger.tagName === 'BUTTON') {
      trigger.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        ddItems.forEach(function (o) { if (o !== item) closeDd(o); });
        item.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    ['mouseenter', 'focusin'].forEach(function (evt) {
      item.addEventListener(evt, function () { trigger.setAttribute('aria-expanded', 'true'); });
    });
    ['mouseleave', 'focusout'].forEach(function (evt) {
      item.addEventListener(evt, function () {
        if (!item.matches(':hover') && !item.contains(document.activeElement) && !item.classList.contains('is-open')) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  });

  document.addEventListener('click', function (e) {
    ddItems.forEach(function (item) {
      if (item.classList.contains('is-open') && !item.contains(e.target)) closeDd(item);
    });
  });

  /* ---------- Clavier : Échap + piège de focus dans le drawer ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (drawer && drawer.classList.contains('open')) { closeDrawer(); return; }
      if (searchBar && searchBar.classList.contains('open')) {
        setSearch(false);
        if (searchToggle) searchToggle.focus();
        return;
      }
      var openItem = null;
      ddItems.forEach(function (item) {
        if (item.classList.contains('is-open') || item.contains(document.activeElement)) openItem = item;
      });
      if (openItem) {
        closeDd(openItem);
        var t = openItem.querySelector('.nwidea-nav__trigger');
        if (t) t.focus();
      }
      return;
    }

    if (e.key !== 'Tab' || !drawer || !drawer.classList.contains('open')) return;

    var items = Array.prototype.filter.call(
      drawer.querySelectorAll(FOCUSABLE),
      function (el) { return el.offsetParent !== null; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ---------- Pastille panier ---------- */
  /* nwidea-cart.js réécrit le texte de la pastille (AJAX) : on recopie la valeur
     dans data-count, utilisé par le CSS pour la masquer quand le panier est vide. */
  var dot = document.querySelector('.nwidea-header__cart .nwidea-header__dot');
  if (dot && window.MutationObserver) {
    var syncDot = function () {
      var n = (dot.textContent || '').trim();
      dot.setAttribute('data-count', n);
      var cartLink = dot.closest('.nwidea-header__cart');
      if (cartLink) cartLink.setAttribute('aria-label', 'Panier, ' + (n || '0') + ' article' + (parseInt(n, 10) > 1 ? 's' : ''));
    };
    syncDot();
    new MutationObserver(syncDot).observe(dot, { childList: true, characterData: true, subtree: true });
  }
})();
